import React from 'react'

const Manual_inventario_ajuste_inventario = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Inventario - Ajuste de Inventario
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía explica paso a paso cómo crear un Ajuste de Inventario para mantener niveles de existencias precisos. Detalla los campos a completar, como el nombre, la fecha y el estado del inventario. Su uso permite gestionar el inventario de manera eficiente, asegurando ajustes correctos y registros precisos.
        </p>
        <iframe
          src="https://scribehow.com/embed/Inventario__Ajuste_de_Inventario__2r4WTh0AR9Gc7Wt2u9qmGQ?as=scrollable"
          className="scribe-iframe-general-42"
          width="100%"
          height="5650"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_inventario_ajuste_inventario